import React from 'react'
import AriaModal from 'react-aria-modal'

export default ({ className, modalClassName, ...props }) => {
  return (
    <AriaModal
      className={modalClassName}
      portalClassName={className}
      {...props}
    />
  )
}
